var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"textF"},[_vm._v(_vm._s(_vm.Text))]),_c('div',{staticClass:"valueF"},[_vm._v(_vm._s(_vm.Value))])])}
var staticRenderFns = []

export { render, staticRenderFns }